var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.619 23a1.05 1.05 0 01-.938-.58l-3.109-6.22a1.052 1.052 0 01.075-1.066l5.02-6.8-6.8 5.018a1.05 1.05 0 01-1.065.075l-6.223-3.11A1.047 1.047 0 011.685 8.4L21.59 1.064a1.047 1.047 0 011.345 1.345L15.6 22.315a1.045 1.045 0 01-.925.683l-.056.002z"
  })));
}
export default SvgSend;